/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { msdyn365Commerce } from '../index';
import { CacheType } from '../interfaces';

/**
 * Commerce Input action
 */
export class CommerceEntityInput {
    private _cacheObjectType: string;
    private _cachekey: string;
    private _dataCacheType: CacheType;

    constructor(options: { shouldCacheOutput?: boolean; cacheObjectType: string; cacheKey: string; dataCacheType?: CacheType }) {
        this._cacheObjectType = options.cacheObjectType;
        this._cachekey = options.cacheKey;
        this._dataCacheType = options.dataCacheType || (options.shouldCacheOutput ? 'request' : 'none');
    }

    public getApiUrl = (url: string): string => {
        return `${msdyn365Commerce.apiSettings.baseUrl}${url}`;
    };

    public getCacheObjectType = () => this._cacheObjectType;
    public getCacheKey = () => this._cachekey;
    public dataCacheType = () => this._dataCacheType;

    /**
     * @deprecated shouldCacheOutput has ben deprecated in favor of dataCacheType
     */
    public shouldCacheOutput = () => this._dataCacheType === 'request';
}
